import React, { useEffect } from 'react';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import FormLabel from '@material-ui/core/FormLabel';
import TextField from '@material-ui/core/TextField';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import Button from '@material-ui/core/Button';
import EditIcon from '@material-ui/icons/Edit';
import IconButton from '@material-ui/core/IconButton';
import Paper from '@material-ui/core/Paper';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Popper from '@material-ui/core/Popper';
import CheckIcon from '@material-ui/icons/Check';
import CloseIcon from '@material-ui/icons/Close';
import CircularProgress from '@material-ui/core/CircularProgress';

import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import SuccessUpdateAlert from '../TicketDetails/SuccessUpdateAlert';
import WagonNumberAutoComplete from '../WagonNumberAutocomplete/WagonNumberAutocomplete';
import ApiService from '../../services/ApiService';
import InvoicesTable from './InvoicesTable';
import InvoiceDetails from '../AddInvoicePage/InvoiceDetails/InvoiceDetails';
import CancelPopUp from '../AddInvoicePage/ConfirmationPopUps/CancelPopUp';
import useStyles from './styles';

export default function InvoicesResearchPage() {
  const classes = useStyles();
  const [supplier, setSupplier] = React.useState('');
  const [activityType, setActivityType] = React.useState('');
  const [invoiceNumber, setInvoiceNumber] = React.useState('');
  const [startDate, setStartDate] = React.useState(null);
  const [endDate, setEndDate] = React.useState(null);

  const [wagonNumber, setWagonNumber] = React.useState('');
  const [ticketNumbers, setTicketNumbers] = React.useState([]);
  const [selectedTicketNumber, setSelectedTicketNumber] = React.useState('');
  const [loading, setLoading] = React.useState(false);
  const [displayEditInvoiceDetails, setDisplayEditInvoiceDetails] =
    React.useState(false);

  const [invoices, setInvoices] = React.useState(null);
  const [selectedInvoices, setSelectedInvoices] = React.useState([]);
  const [deletedInvoices, setDeletedInvoices] = React.useState([]);
  const [updatedInvoices, setUpdatedInvoices] = React.useState([]);

  const [invoicesUpdatedMessage, setInvoicesUpdatedMessage] =
    React.useState(null);
  const [hasFilters, setHasFilters] = React.useState(false);
  const [displaySuccessPopup, setDisplaySuccessPopup] = React.useState(false);
  const [openCancelEditInvoicePopUp, setOpenCancelEditInvoicePopUp] =
    React.useState(false);
  const [validationErrors, setValidationErrors] = React.useState([]);
  const [suppliersList, setSuppliersList] = React.useState([]);

  function getWagonNumber(selectedWagonNumber) {
    setWagonNumber(selectedWagonNumber);
  }

  useEffect(() => {
    if (
      supplier !== '' ||
      activityType !== '' ||
      wagonNumber !== '' ||
      invoiceNumber !== '' ||
      startDate !== null ||
      endDate !== null
    ) {
      setHasFilters(true);
    }
  }, [supplier, activityType, wagonNumber, invoiceNumber, startDate, endDate]);
  useEffect(() => {
    if (wagonNumber !== '') {
      const wagonList = [wagonNumber];
      ApiService.getAllTicketsForWagonList([...new Set(wagonList)]).then(
        (response) => {
          const mapToTicketNumbers = response.data.map(
            (ticket) => ticket.ticketNumber,
          );
          setTicketNumbers(mapToTicketNumbers.slice());
        },
      );
    } else {
      setTicketNumbers([]);
      setSelectedTicketNumber('');
    }
  }, [wagonNumber]);

  useEffect(() => {
    ApiService.getAllSuppliers().then((response) => {
      setSuppliersList(response.data);
    });
  }, []);

  const dateFormatter = (date) => {
    const isValidDate = Date.parse(date);
    if (Number.isNaN(isValidDate)) {
      return null;
    }
    const offset = date.getTimezoneOffset();
    date = new Date(date.getTime() - offset * 60 * 1000);
    return date.toISOString().split('T')[0];
  };
  function replaceAt(index, replacement, queries) {
    return (
      queries.substr(0, index) +
      replacement +
      queries.substr(index + replacement.length)
    );
  }
  function searchInvoices(initialQuery) {
    setLoading(true);
    const formattedStartDate = dateFormatter(startDate);

    const formattedEndDate = dateFormatter(endDate);

    let queries = '';

    if (initialQuery !== null) {
      queries = initialQuery;
    } else {
      if (supplier !== '') {
        queries = `${queries}&supplier=${supplier}`;
      }
      if (activityType !== '') {
        queries = `${queries}&activityType=${activityType}`;
      }
      if (formattedStartDate !== null && formattedEndDate !== null) {
        queries = `${queries}&startDate=${formattedStartDate}&endDate=${formattedEndDate}`;
      } else if (formattedStartDate !== null) {
        queries = `${queries}&startDate=${formattedStartDate}`;
      } else if (formattedEndDate !== null) {
        queries = `${queries}&endDate=${formattedEndDate}`;
      }
      if (invoiceNumber !== '') {
        queries = `${queries}&invoiceNumber=${invoiceNumber}`;
      }
      if (wagonNumber !== '') {
        queries = `${queries}&wagonNumber=${wagonNumber}`;
      }
      if (selectedTicketNumber !== null && selectedTicketNumber !== '') {
        queries = `${queries}&ticketNumber=${selectedTicketNumber}`;
      }
      queries = replaceAt(0, '?', queries);
    }
    ApiService.searchInvoicesByQueries(queries)
      .then((response) => {
        setInvoices(response.data);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  }
  function getSelectedInvoices(invoicesList) {
    setSelectedInvoices(invoicesList);
  }

  function editInvoices() {
    if (selectedInvoices.length > 0) {
      selectedInvoices.forEach((invoice) => {
        invoice.manualInput = true;
        invoice.maintenanceTicketInvoiceList = [];
        if (invoice.maintenanceTicketNumber !== 'Not found') {
          const ticket = {
            ticketNumber: invoice.maintenanceTicketNumber,
            selected: true,
            ticketDate: invoice.ticketCreationDate,
            plannedType: invoice.plannedType,
            ticketStatus: invoice.ticketStatus,
          };
          invoice.maintenanceTicketInvoiceList.push(ticket);
        }
      });
      setDisplayEditInvoiceDetails(true);
    }
  }
  function getAllInvoices(invoicesList) {
    const removedInvoices = [];
    selectedInvoices.forEach((invoice) => {
      if (
        invoicesList.filter(
          (updatedInvoice) => updatedInvoice.id === invoice.id,
        ).length === 0
      ) {
        removedInvoices.push(invoice);
      }
      return true;
    });
    setDeletedInvoices(removedInvoices);
    setUpdatedInvoices(invoicesList);
  }
  function createFormData(invoicesToBeUpdated, invoicesToBeDeleted) {
    const data = new FormData();
    data.append(
      'updatedInvoices',
      new Blob([JSON.stringify(invoicesToBeUpdated)], {
        type: 'application/json',
      }),
    );
    data.append(
      'deletedInvoices',
      new Blob([JSON.stringify(invoicesToBeDeleted)], {
        type: 'application/json',
      }),
    );
    return data;
  }
  function update() {
    setLoading(true);
    const invoicesToBeUpdated = [];
    updatedInvoices.forEach((invoice) => {
      const updatedInvoiceDate =
        typeof invoice.invoiceDate === 'string' ||
        invoice.invoiceDate instanceof String
          ? invoice.invoiceDate
          : !Number.isNaN(invoice.invoiceDate.getTime()) &&
            Object.prototype.toString.call(invoice.invoiceDate) ===
              '[object Date]'
          ? invoice.invoiceDate.toISOString()
          : null;
      const updatedInvoice = {
        id: invoice.id,
        supplier: invoice.supplier,
        activityType: invoice.activityType,
        invoiceNumber: invoice.invoiceNumber,
        invoiceDate: updatedInvoiceDate,
        eventDate:
          typeof invoice.eventDate === 'string' ||
          invoice.eventDate instanceof String
            ? invoice.eventDate
            : dateFormatter(invoice.eventDate),
        wagonNumber: invoice.wagonNumber,
        amount: invoice.amount,
        purchaseOrder: invoice.purchaseOrder,
      };

      invoice.maintenanceTicketInvoiceList.forEach((ticket) => {
        if (ticket.selected) {
          updatedInvoice.maintenanceTicketNumber = ticket.ticketNumber;
        }
      });
      invoicesToBeUpdated.push(updatedInvoice);
    });
    const invoicesList = createFormData(invoicesToBeUpdated, deletedInvoices);
    ApiService.updateInvoices(invoicesList)
      .then(() => {
        setLoading(false);
        setDisplayEditInvoiceDetails(false);
        setDeletedInvoices([]);
        setSelectedInvoices([]);
        searchInvoices(null);
        setValidationErrors([]);
        setDisplaySuccessPopup(true);
        setInvoicesUpdatedMessage(`Invoices are Successfully updated`);
      })
      .catch((error) => {
        setLoading(false);
        if (error) {
          setValidationErrors(error);
        }
      });
  }
  function confirmCancel() {
    setOpenCancelEditInvoicePopUp(false);
    setDisplayEditInvoiceDetails(false);
    setDeletedInvoices([]);
    setSelectedInvoices([]);
    searchInvoices(null);
    setValidationErrors([]);
  }
  function closeSuccessPopUp() {
    setDisplaySuccessPopup(false);
  }
  function clearFilers() {
    const initialQuery = '?';
    setSupplier('');
    setActivityType('');
    setInvoiceNumber('');
    setStartDate(null);
    setEndDate(null);
    setWagonNumber('');
    setHasFilters(false);

    if (hasFilters) {
      searchInvoices(initialQuery);
    }
  }
  function selectAll(selected) {
    const copy = invoices.slice();
    copy.forEach((invoice) => {
      invoice.selected = selected;
    });
    setInvoices(copy);
    const selectedInvoicesList = copy.filter(
      (invoice) => invoice.selected === true,
    );
    setSelectedInvoices(selectedInvoicesList);
  }

  function PopperMy(props) {
    return (
      <Popper {...props} style={{ width: 200 }} placement="bottom-start" />
    );
  }

  return (
    <div className={classes.root}>
      {displayEditInvoiceDetails && (
        <IconButton
          data-testid="cancel"
          aria-label="cancel"
          className={classes.cancelButton}
          onClick={() => setOpenCancelEditInvoicePopUp(true)}
        >
          <CloseIcon />
        </IconButton>
      )}
      {displayEditInvoiceDetails && (
        <IconButton
          data-testid="update"
          aria-label="update"
          className={classes.saveButton}
          onClick={update}
        >
          <CheckIcon />
        </IconButton>
      )}
      {invoices && invoices.length > 0 && !displayEditInvoiceDetails && (
        <IconButton
          data-testid="edit"
          aria-label="edit"
          className={classes.editButton}
          onClick={editInvoices}
        >
          <EditIcon />
        </IconButton>
      )}
      <Grid
        container
        spacing={0}
        justify="center"
        alignItems="center"
        className={classes.container}
      >
        <Grid container item xs={12} className={classes.fixedGridWidth}>
          <Grid container item xs={10}>
            <Typography className={classes.title}>Invoices Research</Typography>
          </Grid>
          <Grid item xs={2} container justify="flex-end" alignItems="flex-end">
            <Button size="small" disableRipple className={classes.button}>
              <Typography
                data-testid="clear-filters"
                className={
                  hasFilters
                    ? classes.clearFilerButton
                    : classes.clearFilerDisabledButton
                }
                onClick={clearFilers}
              >
                Clear filters
              </Typography>
            </Button>
          </Grid>
        </Grid>

        <Paper elevation={0} className={classes.contentPaper}>
          <Grid container spacing={1} className={classes.gridMargin}>
            <Grid container item xs={12}>
              <Grid container item xs={6}>
                <Grid item xs={3}>
                  <FormLabel className={classes.formLabel}>Supplier</FormLabel>
                </Grid>
                <Grid item xs={3}>
                  <FormLabel className={classes.formLabel}>
                    Invoice number
                  </FormLabel>
                </Grid>
                <Grid item xs={3}>
                  <FormLabel className={classes.formLabel}>
                    Start date{' '}
                  </FormLabel>
                </Grid>
                <Grid item xs={3}>
                  <FormLabel className={classes.formLabel}>End date </FormLabel>
                </Grid>
              </Grid>
              <Grid container item xs={6}>
                <Grid item xs={3}>
                  <FormLabel className={classes.formLabel}>
                    Activity type
                  </FormLabel>
                </Grid>
                <Grid item xs={3}>
                  <FormLabel className={classes.formLabel}>
                    Wagon number
                  </FormLabel>
                </Grid>
                <Grid item xs={3}>
                  <FormLabel className={classes.formLabel}>
                    Ticket number
                  </FormLabel>
                </Grid>
                <Grid item xs={3} />
              </Grid>
            </Grid>
            <Grid container item xs={12}>
              <Grid container item xs={6}>
                <Grid item xs={3}>
                  <Autocomplete
                    classes={{
                      option: classes.option,
                      input: classes.autocompleteInput,
                    }}
                    PopperComponent={PopperMy}
                    fullWidth="true"
                    className={classes.autocomplete}
                    disabled={false}
                    size="small"
                    freeSolo
                    required
                    options={suppliersList}
                    value={supplier}
                    getOptionLabel={(option) => option}
                    ListboxProps={{
                      style: { maxHeight: '14rem' },
                    }}
                    renderOption={(option) => (
                      <>
                        <Typography className={classes.inputDatePicker}>
                          {option}
                        </Typography>
                      </>
                    )}
                    renderInput={(params) => (
                      <TextField
                        disabled={false}
                        {...params}
                        variant="outlined"
                      />
                    )}
                    onChange={(e, newValue) => {
                      setSupplier(newValue);
                    }}
                  />
                </Grid>
                <Grid item xs={3}>
                  <TextField
                    inputProps={{
                      'data-testid': 'input-invoice-number',
                      className: classes.inputStyle,
                    }}
                    className={classes.input}
                    variant="outlined"
                    size="small"
                    value={invoiceNumber}
                    onChange={(e) => {
                      setInvoiceNumber(e.target.value);
                    }}
                  />
                </Grid>
                <Grid item xs={3}>
                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <KeyboardDatePicker
                      className={classes.datePicker}
                      InputProps={{
                        'data-testid': 'select-start-date',
                        className: classes.inputDatePicker,
                      }}
                      disableToolbar
                      inputVariant="outlined"
                      format="dd/MM/yyyy"
                      margin="normal"
                      value={startDate}
                      onChange={(date) => {
                        setStartDate(date);
                      }}
                    />
                  </MuiPickersUtilsProvider>
                </Grid>
                <Grid item xs={3}>
                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <KeyboardDatePicker
                      className={classes.datePicker}
                      InputProps={{
                        'data-testid': 'select-end-date',
                        className: classes.inputDatePicker,
                      }}
                      disableToolbar
                      inputVariant="outlined"
                      format="dd/MM/yyyy"
                      margin="normal"
                      value={endDate}
                      onChange={(date) => {
                        setEndDate(date);
                      }}
                    />
                  </MuiPickersUtilsProvider>
                </Grid>
              </Grid>
              <Grid container item xs={6}>
                <Grid item xs={3}>
                  <FormControl>
                    <Select
                      variant="outlined"
                      displayEmpty
                      className={classes.input}
                      inputProps={{
                        'aria-label': 'Without label',
                        'data-testid': 'select-activity-type',
                        className: classes.inputStyle,
                      }}
                      MenuProps={{ classes: { paper: classes.dropdownStyle } }}
                      value={activityType}
                      onChange={(e) => {
                        setActivityType(e.target.value);
                      }}
                    >
                      <MenuItem value="" disabled>
                        Select an activity type
                      </MenuItem>
                      <MenuItem value="cleaning"> Cleaning</MenuItem>
                      <MenuItem value="transport">Transport</MenuItem>
                      <MenuItem value="repair">Repair</MenuItem>
                      <MenuItem value="others"> Others</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={3}>
                  <WagonNumberAutoComplete
                    wagonNumber={wagonNumber}
                    addingInvoice
                    setWagonNumber={getWagonNumber}
                  />
                </Grid>
                <Grid item xs={3}>
                  <Autocomplete
                    classes={{
                      option: classes.option,
                      input: classes.autocompleteInput,
                    }}
                    className={classes.autocomplete}
                    size="small"
                    freeSolo
                    value={selectedTicketNumber}
                    options={ticketNumbers}
                    getOptionLabel={(option) => option}
                    renderInput={(params) => (
                      <TextField
                        data-testid="ticket-number-autocomplete"
                        placeholder="Enter ticket number"
                        type="text"
                        variant="outlined"
                        {...params}
                      />
                    )}
                    getOptionSelected={(option, value) => option === value}
                    onChange={(event, newValue) => {
                      setSelectedTicketNumber(newValue);
                    }}
                  />
                </Grid>
                <Grid container item xs={3}>
                  <Button
                    data-testid="validate"
                    className={classes.validateButton}
                    variant="contained"
                    autoFocus
                    onClick={() => searchInvoices(null)}
                  >
                    Validate
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Paper>
        {loading && (
          <Paper
            data-testid="loader"
            elevation={0}
            position="absolute"
            zindex="2"
          >
            <CircularProgress className={classes.loader} />
          </Paper>
        )}
      </Grid>
      {invoices && !displayEditInvoiceDetails && (
        <InvoicesTable
          initialInvoices={invoices}
          setSelectedInvoices={getSelectedInvoices}
          selectAll={selectAll}
        />
      )}
      {displayEditInvoiceDetails && (
        <InvoiceDetails
          defaultInvoices={selectedInvoices}
          editMode={displayEditInvoiceDetails}
          activityType={null}
          cancelOver={null}
          saveValidationErrors={validationErrors}
          sendAllInvoices={getAllInvoices}
        />
      )}
      <CancelPopUp
        editMode
        openCancelPopUp={openCancelEditInvoicePopUp}
        confirmCancel={confirmCancel}
        closeCancelPopUp={() => setOpenCancelEditInvoicePopUp(false)}
      />
      <SuccessUpdateAlert
        successPopup={displaySuccessPopup}
        successMessage={invoicesUpdatedMessage}
        handleCloseSuccessUpdateAlert={closeSuccessPopUp}
      />
    </div>
  );
}
